import React from "react";
import "../styles/footer.css";

const Footer = () => {
  return (
    <footer className="footer">
      <p>&copy; 2024 Quiz App. All Rights Reserved.</p>
    </footer>
  );
};

export default Footer;
